export enum APP_ENVIRONMENT {
    FEDRAMP_ENVIRONMENT = 'Fedramp_Environment',
    FEDRAMP_HIGH_ENVIRONMENT = 'Fedramp_High_Environment',
    /**
     * GCC-High (Microsoft Government) Teams tenant whose **Webex** backend is
     * the **commercial** cloud (api.webex.com), selected at runtime via the
     * `webexCloud=commercial` manifest parameter. The Microsoft side
     * (login.microsoftonline.us / graph.microsoft.us) stays on GCC-High; only
     * the Webex side is commercial.
     *
     * This is deliberately NOT a FedRAMP environment: `isFedRampEnvironment`
     * must return `false` for it so the Webex SDK initialises in commercial
     * mode and talks to commercial Webex endpoints. Leaving the SDK in FedRAMP
     * mode here would reproduce the gov-vs-commercial mismatch / 401-429
     * cascade.
     */
    GCC_HIGH_COMMERCIAL_WEBEX_ENVIRONMENT = 'Gcc_High_Commercial_Webex_Environment',
    DEV_ENVIRONMENT = 'Dev_Environment',
    INT_ENVIRONMENT = 'Int_Environment',
    PROD_ENVIRONMENT = 'Prod_Environment'
}

/**
 * FedRAMP-High (GCC-High) shares every security and compliance semantic
 * with the regular FedRAMP environment from the perspective of the Webex
 * SDK and downstream services:
 *
 * Any code that needs to take a "FedRAMP" code path should use this
 * predicate (instead of a strict `=== 'Fedramp_Environment'` comparison)
 * so the two environments cannot drift apart again. Previously the strict
 * check silently put GCC-High traffic onto gov-cloud URLs while the SDK
 * itself stayed in commercial mode, which contributed to the 401/429
 * cascade we observed on `msteams-calling-high.webexgov.us`.
 *
 * Note: `GCC_HIGH_COMMERCIAL_WEBEX_ENVIRONMENT` is intentionally excluded —
 * its Webex backend is commercial, so it must take the commercial SDK path.
 */
export function isFedRampEnvironment(env: string | undefined): boolean {
    return env === APP_ENVIRONMENT.FEDRAMP_ENVIRONMENT
        || env === APP_ENVIRONMENT.FEDRAMP_HIGH_ENVIRONMENT;
}